module.exports = __webpack_public_path__ + "static/media/caret_down_active.4604e691.svg";